export default __webpack_public_path__ + "static/media/000_intro_part1.first.f3dde58b.webp";